import styles from './index.module.scss'
import IconeZapZap from '../LandingPage/IconeZapZap/IconeZapZap'
import Header from './Header/Header'
import Hero from './Hero/Hero'
import ParaQuem from './ParaQuem/ParaQuem'
import Sobre from './Sobre/Sobre'
import Areas from './Areas/Areas'
import ComoFunciona from './ComoFunciona/ComoFunciona'
// Conheca is intentionally not imported: the section is parked while a new
// presentation video is produced. Its embedded YouTube player pulled ~854 KB of
// third-party JavaScript into every landing page load. Re-add <Conheca /> below
// (between ComoFunciona and Depoimentos) once the new video is ready.
import Depoimentos from './Depoimentos/Depoimentos'
import Faq from './Faq/Faq'
import ProximoPasso from './ProximoPasso/ProximoPasso'
import Rodape from './Rodape/Rodape'

const LandingPageV2 = () => (
  <div className={styles.page}>
    <Header />
    <main>
      <Hero />
      <ParaQuem />
      <Sobre />
      <Areas />
      <ComoFunciona />
      <Depoimentos />
      <Faq />
      <ProximoPasso />
    </main>
    <Rodape />
    <div className={styles.wpp}>
      <IconeZapZap />
    </div>
  </div>
)

export default LandingPageV2
